import React from 'react';
import { MapPin, Clock, ArrowRight } from 'lucide-react';

const LOCATIONS = [
  {
    id: "mogador",
    name: "Bar à Salade – Mogador",
    subtitle: null,
    address: "27 rue de Mogador",
    city: "75009 Paris",
    hours: "Lundi – Vendredi · 11h30 – 15h00",
    metro: "Métro Trinité – d'Estienne d'Orves (ligne 12)",
    color: "#80a890",
    orderLink: "https://clicks.tastycloud.fr/f8def329f79cc069cc86029fd12781cb49a501fadf230be5f094e9aeaf656e66/menu/73742",
    mapsLink: "https://maps.google.com/maps?q=27+rue+de+Mogador+75009+Paris",
  },
  {
    id: "godot-salad",
    name: "Bar à Salade – Godot de Mauroy",
    address: "16 rue Godot de Mauroy",
    city: "75009 Paris",
    hours: "Lundi – Vendredi · 11h30 – 15h00",
    metro: "Métro Havre-Caumartin (lignes 3, 9)",
    color: "#80a890",
    orderLink: "https://commandes.grainette.fr/home/1064/2/menu",
    mapsLink: "https://maps.google.com/maps?q=16+rue+Godot+de+Mauroy+75009+Paris",
  },
  {
    id: "godot-pates",
    name: "Fabrique à Pâtes",
    address: "17 rue Godot de Mauroy",
    city: "75009 Paris",
    hours: "Lundi – Vendredi · 11h30 – 14h30",
    metro: "Métro Havre-Caumartin (lignes 3, 9)",
    color: "#EEB52D",
    orderLink: "https://commandes.grainette.fr/home/4404/2/menu",
    mapsLink: "https://maps.google.com/maps?q=17+rue+Godot+de+Mauroy+75009+Paris",
  },
];

export default function OuNousTrouver() {
  return (
    <div className="bg-[#FAFAFA] min-h-screen pt-16" data-testid="locations-page">
      {/* Header */}
      <div className="py-16 px-6 bg-[#F5F5F5] border-b border-gray-100">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] mb-3" style={{ color: '#80a890' }}>
            Paris 9e
          </p>
          <h1
            className="text-5xl sm:text-6xl font-black mb-4"
            style={{ fontFamily: 'Barlow, sans-serif', color: '#2A3630' }}
          >
            Où nous trouver ?
          </h1>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Retrouvez nos restaurants au cœur du 9e arrondissement de Paris
          </p>
        </div>
      </div>

      {/* Locations */}
      <section className="py-16 px-6 bg-[#F5F5F5]">
        <div className="max-w-6xl mx-auto space-y-6">
          {LOCATIONS.map((loc) => (
            <div
              key={loc.id}
              data-testid={`location-card-${loc.id}`}
              className="bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-md transition-shadow"
            >
              {/* Barre couleur haut */}
              <div className="h-1.5 w-full" style={{ backgroundColor: loc.color }} />

              <div className="p-7 flex flex-col sm:flex-row sm:items-center justify-between gap-6">
                {/* Infos */}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-3">
                    <h2 className="text-2xl font-black" style={{ fontFamily: '"Barlow", sans-serif', color: '#2A3630' }}>
                      {loc.name}
                    </h2>
                    {loc.subtitle && (
                      <span className="text-xs font-semibold px-2 py-1 rounded-full text-white" style={{ backgroundColor: loc.color }}>
                        {loc.subtitle}
                      </span>
                    )}
                  </div>
                  <div className="space-y-2">
                    <div className="flex items-center gap-2 text-gray-500 text-sm">
                      <MapPin size={14} className="shrink-0" style={{ color: loc.color }} />
                      <span>{loc.address}, {loc.city}</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-500 text-sm">
                      <Clock size={14} className="shrink-0" style={{ color: loc.color }} />
                      <span>{loc.hours}</span>
                    </div>
                    <div className="flex items-start gap-2 text-gray-400 text-xs">
                      <span className="mt-0.5 shrink-0">M</span>
                      <span>{loc.metro}</span>
                    </div>
                  </div>
                </div>

                {/* Boutons */}
                <div className="flex flex-row sm:flex-col gap-2 shrink-0">
                  <a
                    href={loc.mapsLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`maps-btn-${loc.id}`}
                    className="px-5 py-2.5 text-sm font-semibold rounded-full border-2 btn-lift text-center"
                    style={{ borderColor: loc.color, color: loc.color }}
                  >
                    Itinéraire
                  </a>
                  <a
                    href={loc.orderLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`order-btn-location-${loc.id}`}
                    className="inline-flex items-center justify-center gap-2 px-5 py-2.5 text-sm font-semibold text-white rounded-full btn-lift"
                    style={{ backgroundColor: loc.color }}
                  >
                    Commander <ArrowRight size={13} />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Contact info */}
      <section className="py-12 px-6 bg-[#F5F5F5]">
        <div className="max-w-xl mx-auto text-center">
          <h2
            className="text-2xl font-black mb-4"
            style={{ fontFamily: 'Barlow, sans-serif', color: '#2A3630' }}
          >
            Une question ?
          </h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="mailto:contact@grainette.fr"
              data-testid="email-link"
              className="flex items-center gap-2 text-gray-600 hover:text-sage transition-colors"
            >
              <span className="text-sm">contact@grainette.fr</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
